import { ActionReducerMapBuilder, AsyncThunk } from '@reduxjs/toolkit';
import { IstateVv } from '../vv-types';
import {
  base64ImageRecognition,
  recognitionResultChecker,
} from '../../../service/rest/scan-data-service/scan-data-api';

const scanDataReducers = (builder: ActionReducerMapBuilder<IstateVv>) => {
  builder

    /// распознование картинки
    .addCase(base64ImageRecognition.pending, (state, action) => {
      state.loading[base64ImageRecognition.typePrefix] = true;
    })
    .addCase(base64ImageRecognition.fulfilled, (state, action) => {
      state.loading[base64ImageRecognition.typePrefix] = false;
      state.errors[base64ImageRecognition.typePrefix] = null;
      state.data[base64ImageRecognition.typePrefix] = action.payload;
    })
    .addCase(base64ImageRecognition.rejected, (state, action) => {
      state.loading[base64ImageRecognition.typePrefix] = false;

      if (action.payload) {
        state.errors[base64ImageRecognition.typePrefix] =
          action.payload.message;
      } else {
        state.errors[base64ImageRecognition.typePrefix] =
          action.error.message || `Неизвестная ошибка`;
      }
    })

    /// Статус распозноваия
    .addCase(recognitionResultChecker.pending, (state, action) => {
      state.loading[recognitionResultChecker.typePrefix] = true;
    })
    .addCase(recognitionResultChecker.fulfilled, (state, action) => {
      state.loading[recognitionResultChecker.typePrefix] = false;
      state.data[recognitionResultChecker.typePrefix] = action.payload;
      state.errors[recognitionResultChecker.typePrefix] = null;
    })
    .addCase(recognitionResultChecker.rejected, (state, action) => {
      state.loading[recognitionResultChecker.typePrefix] = false;
      state.data[recognitionResultChecker.typePrefix] = null;
      if (action.payload) {
        state.errors[recognitionResultChecker.typePrefix] =
          action.payload.message;
      } else {
        state.errors[recognitionResultChecker.typePrefix] =
          action.error.message || `Неизвестная ошибка`;
      }
    });
};

export default scanDataReducers;
